import React, { FC, memo } from 'react';
import { Column } from '@uikit/Tables/types';
import { idType } from '@src/types';
import TableCell from './TableCell';
import { ModalType } from '@uikit/Modal/modals/constants';
import { CustomTableProps } from '@uikit/Tables/TableDynamic/constants';

interface TableBodyProps {
  rows: any[];
  columnOrder: Column[];
  selectedItem: idType | null;
  abilities: string[];
  modalName?: string;
  tableName?: string;
  openModal?: (name: string, id: idType) => void;
  onEditClick?: (id: idType) => void;
  onAuditClick?: (id: idType, type: ModalType, name?: string) => void;
  onImageClick?: (image: string, uploadedBy: string) => void;
  onFieldClick?: (row: any, field: string) => void;
  handleSelectedRow?: (id: idType) => void;
  handleDeleteRow?: (id: idType) => void;
  statusSetter?: (id: idType, status: boolean) => void;
  setSelectedItem: (id: idType) => void;
  onUpdate?: CustomTableProps['onUpdate'];
}

const TableBody: FC<TableBodyProps> = memo(
  ({
    rows,
    columnOrder,
    selectedItem,
    abilities,
    modalName,
    tableName,
    openModal,
    onEditClick,
    onAuditClick,
    onImageClick,
    onFieldClick,
    handleSelectedRow,
    handleDeleteRow,
    statusSetter,
    onUpdate,
    setSelectedItem,
  }) => (
    <tbody>
      {rows.map((row, index) => (
        <tr
          key={row.id}
          className={`draggable-row ${selectedItem === row.id ? 'active' : ''}`}
          onClick={() => handleSelectedRow?.(row.id)}
        >
          {columnOrder.map((col) => (
            <td
              key={col.field}
              className={
                col.type === 'status' || col.type === 'buttons'
                  ? 'non_hidden'
                  : ''
              }
            >
              <TableCell
                col={col}
                row={row}
                index={index}
                abilities={abilities}
                modalName={modalName}
                tableName={tableName}
                openModal={openModal}
                onEditClick={onEditClick}
                onAuditClick={onAuditClick}
                onImageClick={onImageClick}
                onFieldClick={onFieldClick}
                handleSelectedRow={handleSelectedRow}
                handleDeleteRow={handleDeleteRow}
                statusSetter={statusSetter}
                onUpdate={onUpdate}
                setSelectedItem={setSelectedItem}
              />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  )
);

TableBody.displayName = 'TableBody';
export default TableBody;
